var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.geogrid)?_c('div',{staticClass:"app-gg-wrapper"},[(!_vm.minimalLayout)?_c('GeogridAside',{attrs:{"geogrid":_vm.geogrid,"logo-path":_vm.logoPath},on:{"selectCompetitor":_vm.selectCompetitor}}):_vm._e(),_vm._v(" "),_c('GeogridMap',{attrs:{"geogrid":_vm.geogrid,"map-key":_vm.mapKey,"initial-center":[_vm.geogrid.attrs.gridCenterLng, _vm.geogrid.attrs.gridCenterLat],"features":{
      searchZones: true,
      zipZones: true,
      inmapStats: _vm.minimalLayout,
      inmapBusiness: _vm.minimalLayout
    }},on:{"selectCompetitor":_vm.selectCompetitor}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }